<template>
<v-container fluid class="login-full">
  <v-card class="ma-2 ">
    <v-card-title>
      Payment
      <v-spacer></v-spacer>
      <v-btn depressed fab small color="primary" outlined>
        <v-icon>help</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" md="3" class="pa-2">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="290px"
            v-model="fromMeun"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fromDateValue"
                label="From Date"
                prepend-icon="event"
                hide-details
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMeun = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" class="pa-2">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="290px"
            v-model="toMeun"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="toDateValue"
                label="To Date"
                prepend-icon="event"
                hide-details
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMeun = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" class="px-2 pt-5">
          <v-autocomplete
            :rules="[v => !!v || 'Payment is required']"
            :items="onlineshoppingList1"
            v-model="selectedOnlineshop"
            prepend-icon="business"
            label="OnlineShopping"
            item-text="name"
            placeholder=" "
            hide-details
            return-object
            required
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" class="pa-2 pt-3 text-md-left text-right">
          <v-btn depressed color="primary" class="mx-2" @click="searchPaymentList">
            <v-icon>search</v-icon>
          </v-btn>
          <v-dialog v-model="paymentDialog" persistent width="500">
            <template v-slot:activator="{ on }">
              <v-btn depressed color="primary" v-on="on">
                <v-icon>add</v-icon>
                <span class="ml-2 d-none d-sm-flex">Payment</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline primary white--text">Payment</v-card-title>
              <v-card-text class="pt-4">
                <v-form ref="form" v-model="validPayment" v-on:submit.prevent lazy-validation>
                  <v-autocomplete
                    :rules="[v => !!v || 'Onlineshopping is required']"
                    :items="onlineshoppingList"
                    v-model="payment.onlineshopping"
                    name="onlineshoppingList"
                    label="OnlineShopping"
                    item-text="name"
                    return-object
                    placeholder=" "
                    required
                    dense
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="payment.deliveryDto"
                    name="onlineshoppingDelivery"
                    :items="deliveryManList"
                    item-text="profileName"
                    label="Collector"
                    placeholder=" "
                    return-object
                    class="pt-3"
                    required
                    dense
                  ></v-autocomplete>
                  <v-autocomplete
                    :rules="[v => !!v || 'Bank Type is required']"
                    v-model="payment.bankDto"
                    name="onlineshoppingBank"
                    item-text="bankTypeName"
                    :items="bankList"
                    label="Bank Type"
                    placeholder=" "
                    return-object
                    class="pt-3"
                    required
                    dense
                  ></v-autocomplete>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                    v-model="receiverMeun"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="receiveDate"
                        name="receiveDate"
                        label="Receive Date"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :allowed-dates="allowedDate"
                      :type="datePickerType"
                      v-model="receiver"
                      @input="receiverMeun = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-text-field
                    v-model="payment.payment"
                    name="paymenyOfPayment"
                    :rules="paymentRule"
                    placeholder=" "
                    label="Payment"
                    required
                  ></v-text-field>
                </v-form>
                <v-radio-group v-model="paymentType" row>
                  <v-radio label="Get From OS" value="plus"></v-radio>
                  <v-radio label="Paid To OS" value="minus"></v-radio>
                </v-radio-group>
                <template>
                  STATUS
                  <span class="font-weight-bold">{{payment.itemStatus}}</span>
                </template>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="payment.transactionId == 0"
                  @click="addPaymentByDate"
                  :disabled="!validPayment"
                  color="primary"
                  depressed
                >
                  <v-icon>save</v-icon>
                  <span class="ml-2">save</span>
                </v-btn>
                <v-btn
                  @click="updatePaymentByDate"
                  :disabled="!validPayment"
                  color="primary"
                  depressed
                  v-else
                >Update</v-btn>
                <v-btn @click="closePaymentDialog" color="error" depressed outlined>
                  <v-icon>close</v-icon>
                  <span class="ml-2">Cancel</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12" class="pa-2">
          <v-data-table
            :headers="paymentHeader"
            :items="paymentList"
            :items-per-page="10"
            class="tbl-info"
            dense
          >
            <template v-slot:item.payment="{ item }">{{ item.payment | defaultPaymentFormat}}</template>
            <template v-slot:item.action="{ item }">
              <template v-if="item.itemId==0">
                <v-btn icon depressed color="primary" @click="editPaymentByDate(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon depressed color="error" @click="deletePaymentByDate(item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <v-btn icon depressed color="primary" @click="editAdvancePayment(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-container>
</template>
<script>
import onlineshoppingService from "../service/OnlineshoppingService";
import accountUserService from "../service/AccountUserService";
import paymentService from "../service/PaymentService";
import bankTypeService from "../service/BankTypeService";
import { allowedDate } from "../utils";

export default {
  data() {
    return {
      total: 0,
      userType: "",
      paymentType: "plus",
      payment: {
        transactionId: 0,
        osId: null,
        bankTypeId: null,
        deliveryDto: {},
        bankDto: {},
        payment: 0,
        itemStatus: "NONE",
      },
      selectedOnlineshop: { osId: 0, name: "ALL" },
      toMeun: false,
      fromMeun: false,
      receiverMeun: false,
      validPayment: false,
      paymentDialog: false,
      bankList: [],
      paymentList: [],
      deliveryManList: [],
      onlineshoppingList: [],
      onlineshoppingList1: [],
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      receiver: new Date().toISOString().substr(0, 10),
      dateType: "date",
      datePickerType: "date",
      todayDate: "",
      paymentRule: [
        (v) => !!v || "Payment is required",
        (v) => (v && v > 0) || "Payment must be greater than 0",
      ],
      paymentHeader: [
        { text: "OnlineShopping", value: "osName" },
        { text: "User", value: "userAccountDto.profileName" },
        { text: "Collector", value: "deliveryDto.profileName" },
        { text: "BankType", value: "bankTypeName" },
        { text: "Payment", value: "payment" },
        { text: "Status", value: "itemStatus" },
        { text: "Date", value: "receiveDate" },
        { text: "Modified", value: "modifiedDate" },
        { text: "Action", value: "action" },
      ],
    };
  },
  mounted: function () {
    this.userType = this.$store.state.userAccount.role;
    this.getOnlineshopping();
    this.getAccountDeliverys();
    this.getBank();

    this.todayDate = this.formatDate(this.fromDateValue);
    if (this.$route.query.fromDate != undefined) {
      this.fromDateValue = this.formatDate(this.$route.query.fromDate);
    }
    if (this.$route.query.toDate != undefined) {
      this.toDateValue = this.formatDate(this.$route.query.toDate);
    }
    if (this.$route.query.onlineShoppingName != undefined) {
      this.selectedOnlineshop.name = this.$route.query.onlineShoppingName;
    }
    if (this.$route.query.osId != undefined) {
      this.selectedOnlineshop.osId = this.$route.query.osId;
    }
    this.searchPaymentList();
  },
  methods: {
    addPaymentByDate: function () {
      if (this.$refs.form.validate()) {
        var addPayment = this.payment;
        addPayment.osId = this.payment.onlineshopping.osId;
        addPayment.bankTypeId = this.payment.bankDto.bankTypeId;
        console.log(this.receiveDate);
        addPayment.transactionDto = { receiveDate: this.receiveDate };
        console.log(addPayment.transactionDto.receiveDate);
        var conditonPayment = this.payment.payment;
        addPayment.payment =
          this.paymentType == "plus" ? conditonPayment : conditonPayment * -1;
        paymentService.addPaymentByDate(addPayment).then(() => {
          //this.$swal("Successful", "Added New Payment Successful!", "success");
          this.$swal({
     title: "Successful",
     text: "Added New Payment Successful!",
     type: "success",
     timer: 500
     });
          this.fromDateValue = this.todayDate;
          this.paymentDialog = false;
          this.searchPaymentList();
          this.payment = {
            transactionId: 0,
            osId: null,
            bankTypeId: null,
            deliveryDto: {},
            bankDto: {},
            payment: 0,
            itemStatus: "NONE",
          };
          // this.$refs.form.reset();
          this.paymentType = "plus";
        });
      }
    },
    editPaymentByDate: function (payment) {
      console.log(payment);
      this.receiveDate = this.formatDate(payment.receiveDate);
      this.payment = Object.assign({}, payment);
      this.payment.onlineshopping = {
        osId: payment.osId,
        name: payment.osName,
      };
      this.payment.bankDto = {
        bankTypeId: payment.bankTypeId,
        bankTypeName: payment.bankTypeName,
      };
      this.paymentType = payment.payment > 0 ? "plus" : "minus";
      this.payment.payment = Math.abs(payment.payment);
      this.paymentDialog = true;
    },
    updatePaymentByDate: function () {
      this.payment.osId = this.payment.onlineshopping.osId;
      this.payment.bankTypeId = this.payment.bankDto.bankTypeId;
      this.payment.payment =
        this.paymentType == "plus"
          ? this.payment.payment
          : this.payment.payment * -1;
      paymentService.updatePaymentByDate(this.payment).then(() => {
        this.paymentDialog = false;
        this.payment = {
          transactionId: 0,
          osId: null,
          bankTypeId: null,
          deliveryDto: {},
          bankDto: {},
          payment: 0,
          itemStatus: "NONE",
        };
        // this.$refs.form.reset();
        this.paymentType = "plus";
        this.searchPaymentList();
        //this.$swal("Successful", "Update Payment Successful!", "success");
        this.$swal({
     title: "Successful",
     text: "Update Payment Successful!",
     type: "success",
     timer: 500
     });
      });
    },
    deletePaymentByDate: function (payment) {
      this.$swal({
        title: "Are you sure?",
        text: "Delete this Payment",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          // yes
          paymentService
            .deletePaymentByDate(payment.transactionId)
            .then(() => {
              // delete success
              this.$swal("Payment Deleted", {
                icon: "success",
              });
              this.searchPaymentList();
            })
            // delete unsuccess
            .catch((error) => {
              this.$swal("Failed", error.response.data.message, "error");
            });
        }
      });
    },
    searchPaymentList: function () {
      paymentService
        .getPaymentByDataAndOs(
          this.formatDateUrl(this.fromDateValue),
          this.formatDateUrl(this.toDateValue),
          this.selectedOnlineshop.osId
        )
        .then((response) => {
          this.searchHistory(
            this.fromDateValue,
            this.toDateValue,
            this.selectedOnlineshop.osId,
            this.selectedOnlineshop.name
          );
          this.paymentList.splice(0, this.paymentList.length);
          this.paymentList.push(...response);
          this.paymentList.forEach((pay) => {
            this.total += pay.payment;
          });
        });
    },
    searchHistory: function (fromDate, toDate, osId, onlineShoppingName) {
      let query = {
        fromDate: fromDate,
        toDate: toDate,
        osId: osId,
        onlineShoppingName: onlineShoppingName,
      };
      this.$router
        .replace({
          name: "payment",
          query,
        })
        .catch(() => {});
    },
    closePaymentDialog: function () {
      this.payment = {
        transactionId: 0,
        osId: null,
        bankTypeId: null,
        deliveryDto: {},
        bankDto: {},
        payment: 0,
        itemStatus: "NONE",
      };
      this.paymentDialog = false;
      // this.$refs.form.reset();
      this.paymentType = "plus";
    },
    getAccountDeliverys: function () {
      accountUserService.getAccountDeliverys().then((response) => {
        this.deliveryManList.splice(0, this.deliveryManList.length);
        this.deliveryManList.push(...response);
      });
    },
    getOnlineshopping: function () {
      onlineshoppingService.getAllOnlineshopping().then((response) => {
        this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
        this.onlineshoppingList.push(...response);
        this.onlineshoppingList1.splice(0, this.onlineshoppingList1.length);
        this.onlineshoppingList1.push({ osId: 0, name: "ALL" }, ...response);
      });
    },
    getBank: function () {
      bankTypeService.getBank().then((response) => {
        this.bankList.splice(0, this.bankList.length);
        this.bankList.push(
          { bankTypeId: 0, bankTypeName: "CASH" },
          ...response
        );
      });
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    allowedDate: allowedDate,
    editAdvancePayment: function (item) {
      let query = {
        itemId: item.itemId,
      };
      this.$router.push({ path: "/advanceReport", query }).catch(() => {});
    },
  },
  computed: {
    receiveDate: {
      get: function () {
        var receiveDatetemp = "";
        receiveDatetemp = this.formatDate(this.receiver);
        return receiveDatetemp;
      },
      set: function (value) {
        this.receiver = value;
      },
    },
    toDateValue: {
      get: function () {
        var toDatetemp = "";
        toDatetemp = this.formatDate(this.toDate);
        return toDatetemp;
      },
      set: function (value) {
        this.toDate = value;
      },
    },
    fromDateValue: {
      get: function () {
        var fromDatetemp = "";
        fromDatetemp = this.formatDate(this.fromDate);
        return fromDatetemp;
      },
      set: function (value) {
        this.fromDate = value;
      },
    },
  },
};
</script>
<style scoped>
.login-full {
  height: 92vh;
}
</style>